import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import api from "../../api/api";

export const addValuatorIdentityDetails = createAsyncThunk(
	"ValuatorIdentityDetails/add",
	async (data) => {
		try {
			const response = await api.post(`/v1/ValuatorIdentity`, data, {
				headers: {
					"Content-Type": "application/json",
				},
			});
			toast.success("Identity added successfully!");
			return response.data?.data || response.data;
		} catch (error) {
			const res = error.response.data?.data;
			if (res?.Errors && Array.isArray(res.Errors)) {
				res.Errors.forEach((err) => {
					toast.error(err);
				});
			} else {
				toast.error(res?.Message || "Failed to add Identity Detailse");
			}
		}
	},
);
const ValuatorIdentityDetailSlice = createSlice({
	name: "valuatorIdentityDetail",
	initialState: {
		data: [],
		selected: null,
		loading: false,
		error: null,
		successMessage: null,
	},
	reducers: {
		clearValuator(state) {
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder
			//add
			.addCase(addValuatorIdentityDetails.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(addValuatorIdentityDetails.fulfilled, (state, action) => {
				state.loading = false;
				state.successMessage = "Identity added successfully";
				state.data.push(action.payload);
			})
			.addCase(addValuatorIdentityDetails.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			});
	},
});

export const { clearValuator } = ValuatorIdentityDetailSlice.actions;

export default ValuatorIdentityDetailSlice.reducer;
